@use '../../scss/utility/functions' as utility;
@use './round-button-vars.scss';
@use './round-button-common.scss';
@use './timer-animation/timer-animation';

:host {
  @include round-button-vars.wb-round-button-vars;
  display: inline-block;
  position: relative;

  .button {
    @include round-button-common.wb-round-button-common;
  }
}

::slotted(.wb-icon) {
  @include round-button-common.wb-round-button-icon;
}

::slotted(.wb-icon[name*='/']) {
  @include round-button-common.wb-round-button-icon-bds;
}

:host([disabled]) .button {
  @include round-button-common.wb-round-button-disabled;
}

:host([size='s']) {
  @include round-button-vars.wb-round-button-size-s-vars;
}

:host([size='m']) {
  @include round-button-vars.wb-round-button-size-m-vars;
}

:host([size='l']) {
  @include round-button-vars.wb-round-button-size-l-vars;
}

:host([elevation='xs']) {
  @include round-button-vars.wb-round-button-elevation-xs-vars;
}

:host([elevation='s']) {
  @include round-button-vars.wb-round-button-elevation-s-vars;
}

:host([elevation='m']) {
  @include round-button-vars.wb-round-button-elevation-m-vars;
}

:host([elevation='l']) {
  @include round-button-vars.wb-round-button-elevation-l-vars;
}

:host([elevation]) {
  @include round-button-vars.wb-round-button-elevation-vars;
}

:host([theme='dark']) {
  @include round-button-vars.wb-round-button-dark-vars;
}

:host([theme='dark'][elevation]),
:host([theme='dark'][duration]) {
  @include round-button-vars.wb-round-button-dark-elevation-duration-vars;
}

:host([theme='dark'][elevation='s']) .button {
  @include round-button-vars.wb-round-button-dark-elevation-s-vars;
}
